import { render, staticRenderFns } from "./app-guide.vue?vue&type=template&id=db967b68&scoped=true&"
import script from "./app-guide.vue?vue&type=script&lang=js&"
export * from "./app-guide.vue?vue&type=script&lang=js&"
import style0 from "./app-guide.vue?vue&type=style&index=0&id=db967b68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db967b68",
  null
  
)

export default component.exports